/* @flow */

import { em } from 'polished';

export default {
  root: {
    width: em(32),
    height: em(17),
  },
};
